import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { showNotification } from '@epi-actions/overlays';
import emptyApi from '@epi-api/emptyApi';
import { get } from '@epi-helpers/FetchHelpers';
import config from '@epi-config';
import {
  BenefitGroupsResponse,
  IBenefitGroup
} from '@epi-models/pages/BenefitGroups';

export const getBenefitGroups = async (): Promise<BenefitGroupsResponse> =>
  get<BenefitGroupsResponse>(`${config.apiHost}/api/v2/company-benefit-groups`);
export const benefitGroupsApi = emptyApi.injectEndpoints({
  endpoints: build => ({
    getBenefitGroups: build.query<IBenefitGroup[] | [], void>({
      async queryFn(_arg, api) {
        try {
          const data = await getBenefitGroups();
          return { data: data?.items ?? [] };
        } catch (error) {
          api.dispatch(
            showNotification({ message: 'messages.error' }, 'error')
          );
          return { error: error as FetchBaseQueryError };
        }
      },
      keepUnusedDataFor: 1800
    })
  })
});
export const { useGetBenefitGroupsQuery, useLazyGetBenefitGroupsQuery } =
  benefitGroupsApi;
